import React, { useState } from 'react'
import Layout from 'components/shared/Layout'
import Text from 'components/typo/Text'
import HeroTitle from 'components/typo/HeroTitle'
import classnames from 'classnames/bind'
import css from './styles.module.scss'
import FeatureCard from 'src/components/shared/FeatureCard'
import Image from 'components/shared/Image'

const cx = classnames.bind(css)

const CapabilitiesDynamicCards = ({ upperTitle, title, text, cards }) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0)
  const currentCard = cards[currentCardIndex]

  return (
    <Layout type="wrapper" className={css.layout}>
      <div className={css.wrapper}>
        <div className={css.header}>
          <Text className={css.upperTitle}>{upperTitle}</Text>
          <HeroTitle className={css.heroTitle} tag="h2">
            {title}
          </HeroTitle>
          <Text className={css.description}>{text}</Text>
        </div>
        <div className={css.scrollWrapper}>
          <div className={cx(css.labelsRow, css.labelsRowSlider)}>
            {cards &&
              cards.map((card, index) => {
                const isSelected = currentCardIndex === index
                return (
                  card.label && (
                    <div
                      key={index}
                      className={cx(css.cardLabel, {
                        [css.cardLabelSelected]: isSelected,
                        [css.cardLabelNotSelected]: !isSelected,
                      })}
                      onClick={() => setCurrentCardIndex(index)}
                    >
                      <Image
                        className={cx(css.cardLabelIcon, {
                          [css.selectedIcon]: isSelected,
                          [css.notSelectedIcon]: !isSelected,
                        })}
                        media={{ width: 32, height: 32 }}
                        fluid
                        {...card.label.icon}
                        alt={
                          card?.label?.icon?.media?.data.attributes
                            .alternativeText ?? 'icon-image'
                        }
                        style={{ color: '#000' }}
                      />
                      <Text
                        className={cx(css.cardLabelText, {
                          [css.cardLabelTextSelected]: isSelected,
                          [css.cardLabelNotSelected]: !isSelected,
                        })}
                      >
                        {card.label.title}
                      </Text>
                    </div>
                  )
                )
              })}
          </div>
        </div>
        <div className={css.selectedCard}>
          <FeatureCard {...currentCard} index={0} isLeftCentered />
        </div>
      </div>
    </Layout>
  )
}

export default CapabilitiesDynamicCards
